import Link from "next/link";
import React from "react";

import { Container } from "@cgc/ui/layout";
import { Logo } from "@cgc/ui/logo";
import HeroImage from "./HeroImage";
import { DuaColumnProps } from "./types";

const DualColumnHero: React.FC<DuaColumnProps> = ({
  id,
  fluid = true,
  copy,
  buttonsActionCopy,
  bottomCopy,
  buttons = [],
  backgroundColor,
  backgroundImage,
  imageLeft,
}) => {
  return (
    <Container
      id={id}
      fluid={fluid}
      className="bg-cgc-blue relative flex min-h-[435px] flex-col-reverse justify-between lg:flex-row xl:min-h-[420px] 2xl:min-h-[500px]"
      {...{ ...(backgroundColor ? { style: { backgroundColor } } : null) }}
    >
      {imageLeft && <HeroImage backgroundImage={backgroundImage} />}
      <div className="flex w-full flex-col items-center justify-center px-[15px] py-5 md:px-[50px] md:py-[30px] lg:w-1/2">
        <div className="z-10 flex flex-col items-center">
          <Link
            href="/"
            aria-label={"Navigate to Craft Gin Club home page"}
            className="absolute right-3 top-3 md:static"
          >
            <Logo className="mb-5 h-[80px] w-[80px] drop-shadow-lg" circled />
          </Link>
          <div className="pb-2.5">{copy}</div>
          {buttonsActionCopy && buttonsActionCopy}
          {buttons.length > 0 && (
            <div className="my-2.5 flex w-full flex-row justify-center gap-[10px] md:w-auto">
              {buttons}
            </div>
          )}
          {bottomCopy && bottomCopy}
        </div>
      </div>
      {!imageLeft && <HeroImage backgroundImage={backgroundImage} />}
    </Container>
  );
};

export default DualColumnHero;
